import * as React from 'react';
import { css } from '@patternfly/react-styles';
import styles from '@patternfly/react-styles/css/components/OverflowMenu/overflow-menu';
import { OverflowMenuContext } from './OverflowMenuContext';
export var OverflowMenuContent = function OverflowMenuContent(_ref) {
  var className = _ref.className,
      children = _ref.children,
      isPersistent = _ref.isPersistent;
  return React.createElement(OverflowMenuContext.Consumer, null, function (value) {
    return (!value.isBelowBreakpoint || isPersistent) && React.createElement("div", {
      className: css(styles.overflowMenuContent, className)
    }, children);
  });
};